import React, { Component } from "react";
import Steps from "./Steps/StepIndex";

export default class CurrentStep extends Component {
  render() {
    const Current = Steps[this.props.current];

    return this.props.current ? <Current current /> : null;
  }
}



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/components/CurrentStep.js